export default "__VITE_ASSET__Btk4amrM__"